<template>
  <li class="space-y-1" :class="[own ? 'pl-12 text-right' : 'pr-12']">
    <div v-if="created" class="text-sm text-gray-900">
      {{ user.fullName }} <span class="text-gray-600">commented</span> {{ created }}
    </div>

    <div class="p-4 rounded border" :class="[own ? 'bg-green-200 border-green-500' : 'bg-white']">
      {{ comment.content }}
    </div>

    <div>
      <button
        v-if="$user.id === this.comment.userId"
        role="button"
        class="inline-flex text-blue-600 hover:text-blue-500"
        @click="editAction"
      >
        edit
      </button>

      &bull;

      <button
        v-if="$user.id === this.comment.userId"
        role="button"
        class="inline-flex text-blue-600 hover:text-blue-500"
        @click="deleteAction"
      >
        delete
      </button>
    </div>
  </li>
</template>

<script>
import moment from 'moment';

export default {
  name: 'CommentLine',

  props: {
    comment: {
      type: Object,
      required: true,
    },
  },

  computed: {
    created() {
      if (this.comment === undefined) {
        return undefined;
      }

      if (this.comment.created_at === null) {
        return null;
      }

      return moment(this.comment.created_at).fromNow();
    },
    user() {
      return this.$store.state.entities.users.byId[this.comment.userId];
    },
    own() {
      return this.comment.userId === this.$user.id;
    },
  },

  methods: {
    editAction() {
      this.$emit('edit-comment', this.comment);
    },
    deleteAction() {
      this.$emit('delete-comment', this.comment);
    },
  },
};
</script>
